import { render, staticRenderFns } from "./Hasura.vue?vue&type=template&id=3134ad29&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3134ad29')) {
      api.createRecord('3134ad29', component.options)
    } else {
      api.reload('3134ad29', component.options)
    }
    module.hot.accept("./Hasura.vue?vue&type=template&id=3134ad29&", function () {
      api.rerender('3134ad29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/partnerIcons/Hasura.vue"
export default component.exports